import React from 'react';
import GraphqlTable from 'cccisd-graphql-table';
import { assessmentPlans, responseFlags, learners, sites } from '../renders';
import ProviderProgress from './ProviderProgress.js';
import PageHeader from '../../../components/PageHeader';
import providersQuery from './providers.graphql';
import Tabs from 'cccisd-tabs';
import style from '../style.css';
import _get from 'lodash/get';

const now = new Date();

const SupervisorDash = () => {
    const renders = {
        sites: t => {
            const siteList = t.row['descendantGroups.siteList'];
            const districtLabel = t.row['group.label'];
            return sites({
                siteList,
                context: districtLabel,
            });
        },
        learners: t => {
            const learnerList = t.row['childRoles.learnerList'];
            const context = t.row['user.fullNameWithUsername'];
            const hideStudentNames = _get(t.row, 'parentRoles.supervisor.fields.hideStudentNames', false);

            const adjustColumns = columns => {
                if (!hideStudentNames) {
                    return columns;
                }
                return columns.filter(col => col.label !== 'Student Name');
            };

            return learners({ learnerList, context, adjustColumns });
        },
        learnersActivePlans: t => {
            const learnerList = t.row['childRoles.learnerList'];
            const context = t.row['user.fullNameWithUsername'];
            const learnersInActivePlans = learnerList.filter(learner => {
                return learner.selectedAssignmentPlanList.some(plan => plan?.openSessions?.length > 0);
            });

            const hideStudentNames = _get(t.row, 'parentRoles.supervisor.fields.hideStudentNames', false);

            const adjustColumns = columns => {
                if (!hideStudentNames) {
                    return columns;
                }
                return columns.filter(col => col.label !== 'Student Name');
            };

            return learners({ learnerList: learnersInActivePlans, context, adjustColumns });
        },
        totalAssessmentPlans: t => {
            return assessmentPlans({
                planList: t.row.createdAssignmentPlanList,
                context: t.row['user.fullNameWithUsername'],
                row: t.row,
            });
        },
        activeAssessmentPlans: t => {
            const context = t.row['user.fullNameWithUsername'];
            const plans = t.row.createdAssignmentPlanList.filter(plan => plan.openSessions.length > 0);
            return assessmentPlans({ planList: plans, context, row: t.row });
        },
        responseFlags: t => {
            const learnerList = t.row['childRoles.learnerList'];
            const context = t.row['user.fullNameWithUsername'];
            return responseFlags({ row: t.row, learnerList, context });
        },
    };

    const table = (
        <div style={{ background: '#fff', textAlign: 'center' }} className={style.dashboardWrapper}>
            <GraphqlTable
                query={providersQuery}
                graphqlVariables={{ today: now.toJSON() }}
                rowKey="pawn.pawnId"
                renders={renders}
                columns={[
                    { name: 'user.fullNameWithUsername', label: 'Provider', filter: true, sort: true },
                    {
                        name: 'childRoles.learnerCount',
                        label: 'Total Students',
                        sort: true,
                        render: 'learners',
                    },
                    {
                        name: 'learners',
                        label: 'Students with Plans',
                        tooltip: 'Number of students with at least one active plan',
                        render: 'learnersActivePlans',
                    },
                    {
                        name: 'totalAssessmentPlanCount',
                        label: 'Total Assessment Plans',
                        tooltip: 'Number of Assessment Plans that have ever been created',
                        render: 'totalAssessmentPlans',
                    },
                    {
                        name: 'activeAssessmentPlanCount',
                        label: 'Active Assessment Plans',
                        tooltip: 'Number of Assessment Plans that are currently open',
                        render: 'activeAssessmentPlans',
                    },
                    {
                        name: 'flagCount',
                        label: 'Response Flags',
                        sort: true,
                        render: 'responseFlags',
                    },
                ]}
                csvFilename="districts"
            />
        </div>
    );

    const tabList = [
        { name: 'list', title: 'Providers', content: table },
        {
            name: 'progress',
            title: 'PD Progress',
            content: <ProviderProgress />,
        },
    ];

    return (
        <>
            <div className="container">
                <PageHeader
                    title="Supervisor Dashboard"
                    description="View assessment plan activity from your providers"
                />
                <Tabs tabList={tabList} />
            </div>
        </>
    );
};

export default SupervisorDash;
